import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient) { }

  /**
   * Upload Aadhar card file to Azure Blob Storage
   * @param file File to upload
   * @param certificateNumber Certificate number for file naming
   * @returns Observable with file URL
   */
  uploadAadharCard(file: File, certificateNumber: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('customFileName', `${certificateNumber}-aadhar`);
    
    return this.http.post(`${environment.apiUrl}/file/fileUpload`, formData);
  }

  /**
   * Download Aadhar card file from Azure Blob Storage
   * @param fileName File name (blob name) to download
   * @returns Observable with file blob
   */
  downloadAadharCard(fileName: string): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/file/${fileName}`, {
      responseType: 'blob'
    });
  }

  /**
   * Get Aadhar card image URL for display
   * @param fileName File name (blob name)
   * @returns Image URL
   */
  getAadharCardImageUrl(fileName: string): string {
    return `${environment.apiUrl}/file/${fileName}`;
  }
}






